import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { customerApi } from "../../api/client";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";

export default function AccountDashboard() {
  const [profile, setProfile] = useState(null);
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    Promise.all([
      customerApi("/api/customer/me").then(setProfile).catch(() => setProfile(null)),
      customerApi("/api/customer/orders").then(setOrders).catch(() => setOrders([])),
    ]).finally(() => setLoading(false));
  }, []);

  if (loading) return <Typography>Loading…</Typography>;
  if (error) return <Typography color="error">{error}</Typography>;

  const name = profile?.name || profile?.email || "Customer";

  return (
    <Box>
      <Typography variant="h5" sx={{ fontWeight: 600, mb: 2 }}>
        Welcome, {name}
      </Typography>
      <Typography color="text.secondary" sx={{ mb: 3 }}>
        Manage your profile and view your orders.
      </Typography>
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2, mb: 3 }}>
        <Button variant="contained" component={Link} to="/account/profile">
          Edit profile
        </Button>
        <Button variant="outlined" component={Link} to="/account/orders">
          View orders ({orders.length})
        </Button>
      </Box>
      {orders.length > 0 && (
        <Box>
          <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
            Recent orders
          </Typography>
          <Box component="ul" sx={{ m: 0, pl: 2.5 }}>
            {orders.slice(0, 5).map((o) => (
              <li key={o.id}>
                <Link to="/account/orders" style={{ color: "#1b1b1b" }}>
                  Order #{o.id} – {(o.total_paise / 100).toFixed(0)} – {o.status}
                </Link>
              </li>
            ))}
          </Box>
        </Box>
      )}
    </Box>
  );
}
